import { render, staticRenderFns } from "./roleAuthority.vue?vue&type=template&id=496302ab&scoped=true&"
import script from "./roleAuthority.vue?vue&type=script&lang=js&"
export * from "./roleAuthority.vue?vue&type=script&lang=js&"
import style0 from "./roleAuthority.vue?vue&type=style&index=0&id=496302ab&lang=less&scoped=true&"
import style1 from "./roleAuthority.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496302ab",
  null
  
)

export default component.exports